"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tail = void 0;
const slice_1 = require("./slice");
exports.tail = (values) => slice_1.slice(values, 1, values.length);
//# sourceMappingURL=tail.js.map